import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32.7279 32.7279C29.3523 36.1036 24.7739 38 20 38C15.2261 38 10.6477 36.1036 7.27208 32.7279C3.89642 29.3523 2 24.7739 2 20C2 15.2261 3.89642 10.6477 7.27208 7.27208C10.6477 3.89642 15.2261 2 20 2C24.7739 2 29.3523 3.89642 32.7279 7.27208C36.1036 10.6477 38 15.2261 38 20C38 24.7739 36.1036 29.3523 32.7279 32.7279ZM20.0251 25.7714C19.1641 25.7714 18.4126 26.2204 18.0066 26.8997L18.0014 26.9087C17.6024 27.6318 17.5956 28.4805 18.0039 29.1673C18.4163 29.9108 19.1777 30.3 20.0251 30.3C20.8266 30.3 21.5855 29.9074 21.996 29.1673C22.4043 28.4805 22.3976 27.6318 21.9986 26.9086L21.9933 26.8997C21.5895 26.224 20.8399 25.7714 20.0251 25.7714ZM21.9352 22.1429V11.5714C21.9352 10.5641 21.0392 9.70001 20.0251 9.70001C18.9545 9.70001 18.115 10.5701 18.115 11.5714V22.1429C18.115 23.1993 18.9607 24.0143 20.0251 24.0143C21.033 24.0143 21.9352 23.2053 21.9352 22.1429Z"
	})
});
export default SvgExclamationCircle;
